import { makeAutoObservable } from 'mobx';
import { groupByFunction } from './utils/rxjs/groupByFunction';

export class MessageCenterStore {
  root;
  messageCenter = {};
  messageCenterSubject;

  constructor(root) {
    makeAutoObservable(this);
    this.root = root;
    this.initializeStream();
  }

  initializeStream = () => {
    this.messageCenterSubject = groupByFunction(
      'messageType',
      'messageCenter',
      this.root.websocketSubject
    ).subscribe(this.setMsg);
  };

  setMsg = (msg) => {
    this.messageCenter = msg.messages;
  };
}
